/**
 * Qué bocadillos son nuevos en este pintado (spec 024 · FR-010, FR-011).
 *
 * El primero que se ve de un hilo no anima: son los que ya estaban.
 * Solo el tramo que creció desde la última vez. Cambiar de hilo
 * o que se acorte (un barrido) vuelve a empezar, sin baile.
 */
export type EstadoBurbujas = {
    hilo: string | number | null
    visto: number | null
}

export function tramoNuevo(
    hilo: string | number | null,
    n: number,
    estado: EstadoBurbujas,
): { animarDesde: number; estado: EstadoBurbujas } {
    if (estado.hilo !== hilo) {
        return { animarDesde: Number.POSITIVE_INFINITY, estado: { hilo, visto: n } }
    }
    const visto = estado.visto
    if (visto === null) {
        return { animarDesde: Number.POSITIVE_INFINITY, estado: { hilo, visto: n } }
    }
    if (n > visto) {
        return { animarDesde: visto, estado: { hilo, visto: n } }
    }
    if (n < visto) {
        return { animarDesde: Number.POSITIVE_INFINITY, estado: { hilo, visto: n } }
    }
    return { animarDesde: Number.POSITIVE_INFINITY, estado }
}
